import React from 'react';
import {TableHeader} from 'src/components/common/table-common-components';
import {ExecutionQuickOverviewModal} from "src/components/domain-tracker/execution-quick-overview-modal";
import {ExecutionRestartModal} from "src/components/domain-tracker/execution-restart-modal";
import {AppRoutes} from "src/components/common/router-common";
import {SMSWOUnifiedDashboardServiceLambda} from "@amzn/swo-unified-dashboard-service-lambda-js-client";
import {EXECUTION_ID} from "src/constants/domain-tracker";
import {TableTypes} from "src/interfaces/domain-tracker";
import {Button} from "@amzn/awsui-components-react";
import {ServerSideTableHeaderI} from "src/interfaces/server-side-table";
import {EditExecutionDetail} from "src/components/domain-tracker/edit-execution-detail";
import {TerminateExecution} from "src/components/domain-tracker/terminate-execution";

/**
 * Table header for execution list and execution attempts. Will extend it to other tables later.
 * Decides table actions based on table type.
 * @param props
 * @constructor
 */
export const ServerSideTableHeader = (props: ServerSideTableHeaderI) => {
    const selectedItem: SMSWOUnifiedDashboardServiceLambda.Types.Details = props.selectedItems[0] || {};
    const title: string = "Search results"
    const isOnlyOneSelected = props.selectedItems.length === 1;

    return (
        <TableHeader
            {...props}
            title={title}
            actionButtons={props.tableType == TableTypes.EXECUTION_LIST ? <>
                {/* TODO: Implement Refresh button*/}
                {/*<Button icon={"refresh"}*/}
                {/*        onClick={props.handleRefresh}/>*/}
                <Button text={"Promise Details"} target={"_blank"}
                        href={`${AppRoutes.promiseDetail(selectedItem[EXECUTION_ID])}`} icon={"external"}
                        iconAlign={"right"} />

                <ExecutionQuickOverviewModal {...props} />
                <ExecutionRestartModal {...props} />
                <EditExecutionDetail {...props} />
                <TerminateExecution {...props} />
                <Button text={"View attempts"} target={"_blank"}
                        href={`${AppRoutes.executionAttempts(selectedItem[EXECUTION_ID])}`} icon={"external"}
                        disabled={!isOnlyOneSelected}
                        iconAlign={"right"}/>
                <Button text={"Workflow Instance detail"} target={"_blank"}
                        href={`${AppRoutes.executionDetail(selectedItem[EXECUTION_ID])}`} icon={"external"}
                        disabled={!isOnlyOneSelected}
                        iconAlign={"right"}/>
            </> : <>
                <ExecutionQuickOverviewModal {...props} />
            </>}
            description={""}
            totalItems={props.totalItems}
            selectedItems={props.selectedItems}
            updateTools={null}
        />
    );
};


